import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';

const i18n = globalContext.require('@bingads-webui/i18n-amd-loader!campaignui/feature/hotel-center');

export class PreviewGridOptions {
  constructor({
    el,
  }) {
    this.el = el;
    this.tableClasses = ['table', 'table-bordered'];
    this.columns = [
      {
        name: 'Name',
        field: 'Name',
        title: i18n.getString('HotelCenter_Overview_Grid_SubAccount_Name_Label'),
      },
      {
        name: 'OriginalValue',
        field: 'OriginalValue',
        title: i18n.getString('BulkEdit_OldValueHeader'),
        formatValue: i18n.formatDecimalToFixed,
      },
      {
        name: 'NewValue',
        field: 'NewValue',
        title: i18n.getString('BulkEdit_NewValueHeader'),
        formatValue: i18n.formatDecimalToFixed,
      }];
    this.dataSource = {
      type: 'memory',
      data: [],
    };
    this.scrollable = {
      virtual: true,
    };
    this.plugins = {
      pagination: {
        pageSize: 20,
        availablePageSizes: [20, 50, 100, 200, 500],
        enableRandomPage: false,
      },
      placeholder: {
        container: '.bulkedit-noresult-container',
        text: i18n.getString('HotelCenter_BulkEdit_Preview_NoResult'),
      },
    };
  }
}
